module.exports = __webpack_public_path__ + "images/995a3aea2cca3f8c8a00a00e30fe52f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-characters08.jpg
// module id = ./webpack/assets/img/diaryofanant-characters08.jpg
// module chunks = 0